// Shared per-kind constants for the foraging surface. The four
// `Forage*` components in this directory and the page that
// orchestrates them all import from here so a new kind (e.g.
// `mushroom_patch`) is one entry per `Record` rather than five
// scattered `if (kind === ...)` ladders.

import type { ForageKind } from "../api/forage";

export const KIND_LABELS: Record<ForageKind, string> = {
  apple_trees: "Apple",
  strawberry_bushes: "Strawberry",
};

export const KIND_ITEM_ID: Record<ForageKind, string> = {
  apple_trees: "apple",
  strawberry_bushes: "strawberry",
};

export const KIND_GREEN_PNG: Record<ForageKind, string> = {
  apple_trees: "/items/apple_green.png",
  strawberry_bushes: "/items/strawberry_green.png",
};

export const KIND_RED_PNG: Record<ForageKind, string> = {
  apple_trees: "/items/apple_red.png",
  strawberry_bushes: "/items/strawberry_red.png",
};

// Per-kind compensation rotation applied to the inner <img> so the
// fruit sits upright. The strawberry source PNG is drawn ~45°
// clockwise of upright, so we counter-rotate by -45°.
export const SPRITE_BIAS: Record<ForageKind, string | undefined> = {
  apple_trees: undefined,
  strawberry_bushes: "rotate(-45deg)",
};

// XP awarded per harvest, by kind. Mirrors `Doi.Forage.Spec.xp_for/1`
// — duplicated client-side only so the floating "+N XP" label can pop
// instantly on click; the server-confirmed `gained` is what the skill
// row actually credits.
export const KIND_XP: Record<ForageKind, number> = {
  apple_trees: 5,
  strawberry_bushes: 10,
};
